import React from 'react'
import IconSignature from '@anvilco-pkg/ui/components/Icon/IconSignature'
import IconDocumentTemplate from '@anvilco-pkg/ui/components/Icon/IconDocumentTemplate'
import IconLogic from '@anvilco-pkg/ui/components/Icon/IconLogic'
import IconLightning from '@anvilco-pkg/ui/components/Icon/IconLightning'
import IconQuestion from '@anvilco-pkg/ui/components/Icon/IconQuestion'
import IconShieldHalf from '@anvilco-pkg/ui/components/Icon/IconShieldHalf'
import IconHeartBeat from '@anvilco-pkg/ui/components/Icon/IconHeartBeat'
import IconPerson from '@anvilco-pkg/ui/components/Icon/IconPerson'
import IconHome from '@anvilco-pkg/ui/components/Icon/IconHome'
import IconDollar from '@anvilco-pkg/ui/components/Icon/IconDollar'
import IconAI from '@anvilco-pkg/ui/components/Icon/IconAI'
import IconEditBlog from '@anvilco-pkg/ui/components/Icon/IconBlog'
import IconOpenBook from '@anvilco-pkg/ui/components/Icon/IconOpenBook'
import IconOpenSource from '@anvilco-pkg/ui/components/Icon/IconOpenSource'
import IconCoding from '@anvilco-pkg/ui/components/Icon/IconAPIDocumentation'
import IconWebform from '@anvilco-pkg/ui/components/Icon/IconWebform'
import IconInfo from '@anvilco-pkg/ui/components/Icon/IconInfo'
import IconStarFilled from '@anvilco-pkg/ui/components/Icon/IconStarFilled'
import IconBook from '@anvilco-pkg/ui/components/Icon/IconBook'
import IconEasy from '@anvilco-pkg/ui/components/Icon/IconEasy'
import IconPuzzle from '@anvilco-pkg/ui/components/Icon/IconPuzzle'
import MarketingIconAnvilPlatform from '../../src/components/illustrations/marketing-icons/MarketingIconAnvilPlatform'
import {
  BLOG_SLUG,
  HELP_SLUG,
  FORMS_SLUG,
  ASK_ANVIL_SLUG,
  FEATURE_SLUG,
} from 'consts'
import Navbar from '../components/Navbar'
import baseTheme from 'theme'

export const menuObject = [
  {
    title: 'Products',
    subMenu: [
      {
        title: 'Anvil Document SDK',
        to: '/products/document-sdk/',
        desc: 'All you need to automate documents',
        icon: <MarketingIconAnvilPlatform />,
        bg: baseTheme.colors.offWhite,
        bgHover: baseTheme.colors.offWhite,
      },
      {
        title: 'Anvil Workflows',
        to: '/products/workflows/',
        desc: 'Automate complex document processes',
        icon: <IconLogic />,
        bg: baseTheme.colors.reds[10],
        bgHover: baseTheme.colors.reds[20],
      },
      {
        title: 'Webforms',
        to: '/products/webforms/',
        desc: 'Collect data with mobile-friendly webforms',
        icon: <IconWebform />,
        bg: baseTheme.colors.greens[10],
        bgHover: baseTheme.colors.greens[20],
      },
      {
        title: 'Document AI',
        to: '/products/document-ai/',
        desc: 'Faster way to build workflows',
        icon: <IconAI fill="white" />,
        bg: baseTheme.colors.blacks[50],
        bgHover: baseTheme.colors.blacks[60],
      },
      {
        title: 'Etch E-sign',
        to: '/products/etch/',
        desc: 'Embed white-labeled e-signatures',
        icon: <IconSignature />,
        bg: baseTheme.colors.yellows[20],
        bgHover: baseTheme.colors.yellows[30],
      },
      {
        title: 'PDF Services',
        to: '/products/pdf-services/',
        desc: 'Fill PDFs with collected or stored data',
        icon: <IconDocumentTemplate />,
        bg: baseTheme.colors.blues[10],
        bgHover: baseTheme.colors.blues[20],
      },
    ],
  },
  {
    title: 'Industries',
    subMenu: [
      {
        title: 'Insurance',
        to: '/solutions/insurance/',
        icon: <IconShieldHalf />,
        desc: 'Rate, quote, and bind faster',
      },
      {
        title: 'Human resources',
        to: '/solutions/human-resources/',
        icon: <IconPerson />,
        desc: 'Automate onboarding documents',
      },
      {
        title: 'Real estate',
        to: '/solutions/real-estate/',
        icon: <IconHome />,
        desc: 'Secure workflows for buying, selling, renting',
      },
      {
        title: 'Healthcare',
        to: '/solutions/healthcare/',
        icon: <IconHeartBeat />,
        desc: 'Launch HIPAA compliant document workflows',
      },
      {
        title: 'Finance',
        to: '/solutions/finance/',
        icon: <IconDollar />,
        desc: 'Automate documents for financial products',
      },
      {
        title: 'Case studies',
        to: '/blog/customer-stories/',
        icon: <IconStarFilled />,
        desc: 'Learn how businesses have grown with Anvil',
      },
    ],
  },
  {
    title: 'Resources',
    subMenu: [
      {
        title: 'Form library',
        to: `/${FORMS_SLUG}/`,
        desc: 'Ship faster with pre-made form templates',
        icon: <IconBook />,
      },
      {
        title: 'Blog',
        to: `/${BLOG_SLUG}/`,
        desc: 'New features, industry news, customer stories',
        icon: <IconEditBlog />,
      },
      {
        title: 'Help center',
        to: `/${HELP_SLUG}/`,
        desc: 'Step-by-step guides for using Anvil',
        icon: <IconInfo />,
      },
      {
        title: 'Product updates',
        to: `https://changelog.useanvil.com/en`,
        desc: 'New features & app improvements',
        icon: <IconLightning />,
      },
      {
        title: 'Ask Anvil',
        to: `/${ASK_ANVIL_SLUG}/`,
        desc: 'Answers to your paperwork questions',
        icon: <IconQuestion />,
      },
      {
        title: 'Features',
        to: `/${FEATURE_SLUG}/`,
        desc: 'Overview of all Anvil features',
        icon: <IconPuzzle />,
      },
    ],
  },
  {
    title: 'Developers',
    subMenu: [
      {
        title: 'Get started',
        to: '/developers/',
        desc: 'A quick introduction to building with Anvil',
        icon: <IconEasy />,
      },
      {
        title: 'Documentation',
        to: '/docs/',
        desc: 'Learn how to build Anvil into your product',
        icon: <IconOpenBook />,
      },
      {
        title: 'API reference',
        to: '/docs/api/graphql/reference/',
        desc: 'GraphQL types, queries, & more',
        icon: <IconCoding />,
      },
      {
        title: 'Open source',
        to: '/open-source/',
        desc: 'Pre-written clients to simplify development',
        icon: <IconOpenSource />,
      },
      {
        title: 'Engineering blog',
        to: `/${BLOG_SLUG}/engineering/`,
        desc: 'Technical topics, how-tos, & more',
        icon: <IconEditBlog />,
      },
    ],
  },
  {
    title: 'Pricing',
    to: '/pricing/',
  },
]

const renderNavbar = (props) => {
  return <Navbar menuObject={menuObject} {...props} />
}

export default renderNavbar
